import upperFirst from "lodash/upperFirst";
import { v4 as uuidv4 } from "uuid";
import type {
  HomeTabsMetaType,
  HomeTabsMobileSegmentAsMetaType,
} from "@circle-react/components/BrandedAppsBuilderUI/types/HomeTabs.types";
import type {
  BaseBlock,
  RootBlock,
} from "@circle-react-shared/BuilderUI/DataModel.types";

export interface HomeTabsBlockInitialValues {
  homeTabMeta: HomeTabsMobileSegmentAsMetaType;
  homeTabsMetaFromAllSegments: HomeTabsMobileSegmentAsMetaType[];
}

export const HOME_TABS_ROOT_BLOCK_TYPE = "hometabs" as const;

const homeTabsI18nKey = "branded_apps_builder_ui.home_tabs";
export const createHomeTabsRootBlockFromMobileSegments = ({
  homeTabMeta,
  homeTabsMetaFromAllSegments,
}: HomeTabsBlockInitialValues): RootBlock => ({
  id: uuidv4(),
  type: "root",
  meta: {
    name: upperFirst(homeTabMeta.custom_name || homeTabMeta.kind),
    type: HOME_TABS_ROOT_BLOCK_TYPE,
    nameI18n: "builder_ui.prop_type.children",
    version: 1,
    ...homeTabMeta,
  },
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [
        {
          id: uuidv4(),
          type: "hometabs", // key on blockMapping
          meta: {
            name: "Home Tabs",
            nameI18n: homeTabsI18nKey,
            version: 1,
          },
          props: {
            allPagesMeta: {
              prop: "other",
              type: "home-tabs-meta-array",
              value: homeTabsMetaFromAllSegments,
              meta: {
                name: "NavOrder",
                nameI18n: homeTabsI18nKey,
              },
            },
            currentPageMeta: {
              prop: "other",
              type: "home-tabs-meta",
              value: homeTabsMetaFromAllSegments[0],
              meta: {
                name: "CurrentPageMeta",
                nameI18n: homeTabsI18nKey,
              },
            },
          },
        },
      ],
    },
  },
});

interface CreateHomeTabsPageBlockProps {
  allPagesMeta: HomeTabsMetaType[];
  blocks: BaseBlock | BaseBlock[];
  meta: Partial<HomeTabsMetaType>;
}

export const createHomeTabsPageWithTemplateBlock = ({
  meta,
  blocks,
  allPagesMeta = [],
}: CreateHomeTabsPageBlockProps): RootBlock => ({
  id: uuidv4(),
  type: "root",
  meta: {
    id: uuidv4(),
    type: HOME_TABS_ROOT_BLOCK_TYPE,
    nameI18n: "builder_ui.prop_type.children",
    version: 1,
    name: "New Page",
    ...meta,
  },
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [
        {
          id: uuidv4(),
          type: "hometabs", // key on blockMapping
          meta: {
            name: "Home Tabs",
            nameI18n: homeTabsI18nKey,
            version: 1,
          },
          props: {
            allPagesMeta: {
              prop: "other",
              type: "home-tabs-meta-array",
              value: allPagesMeta,
              meta: {
                name: "NavOrder",
                nameI18n: homeTabsI18nKey,
              },
            },
            currentPageMeta: {
              prop: "other",
              type: "home-tabs-meta",
              value: meta,
              meta: {
                name: "CurrentPageMeta",
                nameI18n: homeTabsI18nKey,
              },
            },
          },
        },
        ...(Array.isArray(blocks) ? blocks : [blocks]),
      ],
    },
  },
});
